function popUp(){

    const getButtons = document.querySelectorAll('[data-targetmodal]');

    getButtons.forEach(element => {
        element.addEventListener('click', showModal, false);
    });

    const getHeader = document.querySelector('header.header');
    const getFotter = document.querySelector('footer.footer');
    const getMain = document.querySelector('main.main');

    function showModal(){

        var curScroll = window.pageYOffset;
        let curTarget = this.dataset.targetmodal;

        let getModal = document.querySelector('[data-modalid="'+curTarget+'"]');
        let modalPlace = document.createElement('div');
        modalPlace.classList.add('modal');
        document.body.append(modalPlace);
        modalPlace.insertAdjacentHTML('afterbegin', getModal.innerHTML);
        modalPlace.classList.add('active');
        document.body.classList.add('ow-hidden');
        getHeader.classList.add('blured');
        getFotter.classList.add('blured');
        getMain.classList.add('blured');
        lazyLoadInstance.update();

        let closeBut = modalPlace.querySelector('.modal__close');

        if(this.hasAttribute('data-modalhiddenfield')){
            let hFiled = this.dataset.modalhiddenfield;
            let getHFiled = modalPlace.querySelector('#setlink-prop');
            getHFiled.value = hFiled;
        }
        
        function setFixedClose(){
            if(window.innerWidth > 1023){
                let getRightClose = closeBut.getBoundingClientRect().left;
                let getTopClose = closeBut.getBoundingClientRect().top;
                closeBut.style.position = 'fixed';
                closeBut.style.top = getTopClose + 'px';
                closeBut.style.left = getRightClose + 'px';
                closeBut.style.zIndex = '100';
            }
        }

        function setUnFixedClose(){
            if(window.innerWidth > 1023){
                closeBut.removeAttribute('style');
            }
        }

        setTimeout(setUnFixedClose, 400);
        setTimeout(setFixedClose, 500);

        window.addEventListener("resize", setUnFixedClose, false);
        window.addEventListener("resize", setFixedClose, false);

        function closeMod(){
            modalPlace.classList.remove('active');
            document.body.classList.remove('ow-hidden');
            modalPlace.remove();
            window.scrollTo(0,curScroll);
            getHeader.classList.remove('blured');
            getFotter.classList.remove('blured');
            getMain.classList.remove('blured');
            if(modalPlace.querySelectorAll('video').length != ''){
                modalPlace.querySelectorAll('video')[0].pause();
            }
            window.removeEventListener("resize", setUnFixedClose, false);
            window.removeEventListener("resize", setFixedClose, false);
        }

        function ketDClose(event){
            if (event.code == 'Escape') {
                closeMod();
                document.removeEventListener('keydown', ketDClose, false);
                window.removeEventListener("resize", setUnFixedClose, false);
                window.removeEventListener("resize", setFixedClose, false);
            }
        }

        closeBut.addEventListener("click", closeMod, false);

        document.addEventListener('keydown', ketDClose, false);
    }
}
module.exports = popUp;